import React from "react";
import { connect } from "react-redux";
import WelcomeScreen from "./WelcomeScreen/WelcomeScreen";
import ChooseConnectorsScreen from "./ChooseConnectorsScreen/ChooseConnectorsScreen";
import CssBaseline from "@material-ui/core/CssBaseline";
import withStyles from "@material-ui/core/styles/withStyles";
import { noHeaderCss } from "../../sass/Main";
import Paper from "@material-ui/core/Paper/index";
import InstallCollaborationToolScreen from "./InstallCollaborationToolScreen/InstallCollaborationToolScreen";
import { clearAllWizardState, wizardChooseStep } from "../../redux/actions/gettingStartedWizardActions";
import { fetchConnections } from "../../redux/actions/connectionActions";
import PopUpMessages from "../../components/PopUpMessages/PopUpMessages";
import { removeMessage } from "../../redux/actions/commonActions";
import {Stepper, Step, StepLabel, Button, StepConnector } from '@material-ui/core';

const QontoConnector = withStyles({
  alternativeLabel: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  active: {
    '& $line': {
      borderColor: 'whitesmoke',
    },
  },
  completed: {
    '& $line': {
      borderColor: '#fff',
    },
  },
  line: {
    borderColor: '#4c80c0',
    borderTopWidth: 2,
    borderRadius: 1,
  },
})(StepConnector);

const StepLabelCustom = withStyles({
  root: {
    color: '#fff',
    display: 'flex',
    height: 22,
    alignItems: 'center',
  },
  active: {
    color: '#fff!important'
  },
  completed: {
    color: '#fff!important'
  },
  label: {
    color: "#7eafea",
    fontWeight: 14
  },
  alternativeLabel: {
    "& > .MuiStepIcon-root":{
      color: "#4c80c0"
    },
    "& > .MuiStepIcon-active":{
      color: "#f68b1c"
    },
    "& > .MuiStepIcon-completed":{
      color: "#fff"
    }
  }
})(StepLabel);




class GettingStartedWizard extends React.Component {

  state = {
    activeIndex: 0,
    completedConnector: ""
  };

  componentDidMount(){
    this.props.fetchConnections();
    window.addEventListener('storage', (e) => {
      let completedConnector = localStorage.getItem("connected");
      if(this.state.completedConnector!==completedConnector){
        this.setState({completedConnector:completedConnector});
      }
    });
  }

  componentDidUpdate() {
    this.setActiveIndex();
  }
 
  componentWillUnmount() {
    this.props.clearAllWizardState();   
  }

  setActiveIndex = () => {
    let activeIndex = localStorage.getItem("wizardStep");
    activeIndex = activeIndex?parseInt(activeIndex):0;
    if(this.state.activeIndex !== activeIndex){
      this.setState({activeIndex:activeIndex})
    }
  }

  loadNextStep = () => {
    wizardChooseStep(this.state.activeIndex+1);
    this.setState(prevState => ({activeIndex:prevState.activeIndex+1}));
  }

  loadPrevStep = (index) => {
    this.setState(prevState => ({activeIndex:prevState.activeIndex--}));
  }

  getSalesSignupFlow = () => {  
    switch (this.state.activeIndex) {
      case 1:
        return <ChooseConnectorsScreen 
                connectors={this.props.connectors} 
                area="CRM"
                loadNextStep={this.loadNextStep}
                completedConnector={this.state.completedConnector}
                title="To get started, please select CRM you wish to connect to Responsum."/>;        
      case 2:
        return <ChooseConnectorsScreen 
                connectors={this.props.connectors} 
                area="Collaboration Tool"
                loadNextStep={this.loadNextStep}
                completedConnector={this.state.completedConnector}
                title="Please select collaboration tool you wish to connect to Responsum."/>;  
      case 3:
        return <ChooseConnectorsScreen 
                connectors={this.props.connectors} 
                area="Mail Client"
                loadNextStep={this.loadNextStep} 
                completedConnector={this.state.completedConnector}
                title="Please select mail service you wish to connect to Responsum"/>; 
      case 4:
        return <InstallCollaborationToolScreen />;
      default:
        return <WelcomeScreen />;
    } 
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.mainHolder}>
        <PopUpMessages message={this.props.message} removeMessage={this.props.removeMessage} />
        <main className={classes.main600}>
        <CssBaseline />
        <div className={classes.stepperHolder}>
          <Stepper connector={<QontoConnector /> } className={classes.customStepperStyle} activeStep={this.state.activeIndex} alternativeLabel>
            <Step >
              <StepLabelCustom>Profile</StepLabelCustom>
            </Step>
            <Step >
              <StepLabelCustom>CRM</StepLabelCustom>
            </Step>
            <Step >
              <StepLabelCustom>Collaboration</StepLabelCustom>
            </Step>
            <Step >
              <StepLabelCustom>Email/Calendar</StepLabelCustom>
            </Step>
          </Stepper>
        </div>
        <Paper className={classes.formHolder}>
          {this.getSalesSignupFlow()}
        </Paper>
        </main> 
      </div>
    );
  }
}

const mapStateToProps = state => {

  return {
    wizardStep: state.gettingStartedWizard.wizardStep,
    message: state.common.message, 
    connectors: state.connections,
    oauthStatus: state.connections ? state.connections.oauthStatus : ""
  };
}; 

const GettingStartedWizardStyled = withStyles(noHeaderCss)(GettingStartedWizard);

export default connect(
  mapStateToProps,
  { clearAllWizardState,
    removeMessage,
    wizardChooseStep,
    fetchConnections }
)(GettingStartedWizardStyled);
